"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
export default function CommonAnimationHeight(t0) {
  const $ = _c(15);
  const {
    className,
    children,
    onAnimationCompleted,
    onAnimationStart
  } = t0;
  const containerRef = useRef(null);
  const [height, setHeight] = useState("auto");
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (containerRef.current) {
        const resizeObserver = new ResizeObserver(entries => {
          const observedHeight = entries[0].contentRect.height;
          setHeight(observedHeight);
        });
        resizeObserver.observe(containerRef.current);
        return () => {
          resizeObserver.disconnect();
        };
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const t3 = `${className} tw-overflow-hidden `;
  let t4;
  let t5;
  if ($[2] !== height) {
    t4 = {
      height
    };
    t5 = {
      height
    };
    $[2] = height;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      duration: 0.3
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== children) {
    t7 = <div ref={containerRef}>{children}</div>;
    $[6] = children;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== onAnimationCompleted || $[9] !== onAnimationStart || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== t7) {
    t8 = <motion.div className={t3} style={t4} animate={t5} transition={t6} onAnimationStart={onAnimationStart} onAnimationComplete={onAnimationCompleted}>{t7}</motion.div>;
    $[8] = onAnimationCompleted;
    $[9] = onAnimationStart;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}